module.exports = __webpack_public_path__ + "img/LOGO1.58c9532d.png";